export default "__VITE_ASSET__BgLCCeKc__"